"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloneChip = CloneChip;
const react_1 = __importDefault(require("react"));
const useStyles_1 = require("~/useStyles");
const useStyles = (0, useStyles_1.createUseThemeStyles)((theme) => ({
    chip: {
        "background": "#8fa3bd",
        "padding": "4px 8px",
        "fontFamily": theme.typography.primary,
        "fontWeight": 700,
        "color": "#fff",
        "fontStyle": "italic",
        "fontSize": "16px",
        "@media (orientation: portrait) and (max-width: 400px)": {
            padding: "4px",
            fontSize: "12px",
        },
    },
}));
function CloneChip() {
    const classes = useStyles();
    return react_1.default.createElement("div", { className: classes.chip }, "(clone)");
}
